import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

const WrapperStyle = ({ theme }) => ({
  backgroundColor: `${theme.palette.background.grey.light}`,
  border: `1px solid ${theme.palette.border.main}`,
  borderRadius: 12,
  padding: 16,
  [theme.breakpoints.up('md')]: {
    borderRadius: 16,
    padding: 24
  }
});

export const Wrapper = styled(Stack)(WrapperStyle);
